export function getDateFormatSeparator(dateFormat: string): string {
  if (dateFormat.indexOf('/') >= 0) return '/';
  if (dateFormat.indexOf('-') >= 0) return '-';
  if (dateFormat.indexOf('.') >= 0) return '.';
  return '/';
}

export const stringToDate = (date: string, format: string): Date => {
  /**  @returns {string} '/' or '-' */
  const determineDelimiterFromFormat = (f: string) => f.indexOf('/') >= 0 ? '/' : '-';
  const delimiter = determineDelimiterFromFormat(format);

  const formatItems = format.toLowerCase().split(delimiter);
  const dateItems = date.split(delimiter);

  const monthIndex = formatItems.indexOf('mm');
  const dayIndex = formatItems.indexOf('dd');
  const yearIndex = formatItems.indexOf('yyyy');

  return new Date(Date.UTC(+dateItems[yearIndex], +dateItems[monthIndex] - 1, +dateItems[dayIndex]));
};



// WEBPACK FOOTER //
// ./src/shared/FormAnswer/utils/common.ts